<div class="cabecera">
    <div [class]="(principal) ? 'contenedor-cabecera principal' : 'contenedor-cabecera'">
        <div class="contenedor-titulo">
            <h3 class="cabecera-tit" data-testid="tituloContenedor">
                <a class="link linkMain" *ngIf="paginaEnlace && paginaEnlace!=''; else tituloContenedor"
                    (click)="$event.stopPropagation()" (click)="onEnlace()">
                    <ng-container>
                        <ng-template [ngTemplateOutlet]="tituloContenedor"></ng-template>
                    </ng-container>
                </a>
                <ng-template #tituloContenedor>
                    <h3 [class]="tituloClase">{{titulo}}</h3>
                </ng-template>
            </h3>
            <h4 class="cabecera-sub" *ngIf="subTitulo" data-testid="subTituloContenedor">{{subTitulo}}</h4>
            <neo-estado-label class="ml-10" [estado]="estado" [modoChip]="true"></neo-estado-label>
        </div>
        <div class="botonera" *ngIf="botonera?.length && !desplegable" data-testid="botoneraContenedor">
            <ng-container *ngFor="let boton of botonera">
                <neo-button tabindex="7"  *ngIf="boton?.activo"
                    [basic]="true"
                    [type]="'button'"
                    [raised]="boton?.raised"
                    [stroked]="boton?.stroked"
                    [fab]="boton?.fab"
                    [miniFab]="boton?.miniFab"
                    [basic]="boton?.basic"
                    [flat]="boton?.flat"
                    [text]="boton.label"
                    [color]="boton.color"
                    [disabled]="boton?.disabled"
                    [iconClass]="boton?.iconoClase"
                    [icono]="boton?.icono"
                    [matprefix]="boton?.matprefix"
                    [matsuffix]="boton?.matsuffix"
                    [clase] = "(boton?.clase) ? boton?.clase: 'ml-10'"
                    (click)="(!boton?.disabled) ? accion(boton) : return;"
                ></neo-button>
            </ng-container>
        </div>
        <div class="botonera-minifab" *ngIf="botonera?.length && !desplegable" data-testid="botoneraContenedor">
            <ng-container *ngFor="let boton of botonera">
                <neo-button tabindex="7"  *ngIf="boton?.activo"
                    [miniFab]="true"
                    [type]="'button'"
                    [color]="boton?.color"
                    [disabled]="boton?.disabled"
                    [iconClass]="boton?.iconoClase"
                    [icono]="boton?.icono"
                    [matprefix]="boton?.matprefix"
                    [matsuffix]="boton?.matsuffix"
                    [clase] = "(boton?.clase) ? boton?.clase: 'ml-10'"
                    (click)="(!boton?.disabled) ? accion(boton) : return;"
                ></neo-button>
           
            </ng-container>
        </div>
        <div class="botoneraDesplegable" *ngIf="desplegable" data-testid="botoneraContenedor">
            <neo-boton-desplegable 
                class="btn-desplegable"
                [referenciaElemento]="'botonera-desplegable-cabecera'"
                [disabled] = false
                [mostrarEnDialog]= false
                [strokedBotonPrincipal]=true
                [textoBotonPrincipal]="''"
                [claseBotonPrincipal]="'btn-sm'"
                [botonCancelarDialog]=true
                [alineacionAccionesBotonDespegable]="'center'"
                [accionesBotonDesplegable]="botonera"
                (accion)="accion($event)">
            </neo-boton-desplegable>
        </div>
    </div>
    <div *ngIf="!principal"
        class="contenedor-cuerpo">
        <ng-content></ng-content>
    </div>
</div>


